module.exports = __webpack_public_path__ + "media/images/city/017-new-bridge-of-ronda-4af0fd824cd68394c0de7d2e6f3ec951.svg";